export default "__VITE_ASSET__BHMHZGe2__"